import React, { useState } from "react";
import { useStep } from "@flywire/react-hooks";
import { Modal } from "reactstrap";

import ErrorStep from "./steps/ErrorStep";
import LoadingStep from "./steps/LoadingStep";
import ValidationErrorStep from "./steps/ValidationErrorStep";
import ImportStep from "./steps/ImportStep";
import ImportResultsStep from "./steps/ImportResultsStep";
import { useSelector } from "react-redux";
import { getConfig } from 'config/index';
import "./steps/MassiveLinkSteps.scss";

function MassivePaymentLinkModal(props) {
  const [error, setError] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [uploadOk, setUploadOk] = useState(null);
  const [results, setResults] = useState([]);
  const [fileName, setFileName] = useState(null);

  const paymentLinkValidations = useSelector((state) => state.login.user.paymentLink);
  const userRole = useSelector((state) => state.login.user.userRole);

  const evaluateValidations = () => {
    let canCreateLink = true;
    if (paymentLinkValidations) {
      if (typeof userRole?.toLowerCase === 'function' && userRole.toLowerCase() === 'administrador')  {
        if (getConfig('customConfig.paymentLink.biometricValidation') && !paymentLinkValidations.biometricScan) {
          canCreateLink = false;
        }
      }
      if (getConfig('customConfig.paymentLink.bankAccountValidation') && !paymentLinkValidations.bankAccount) {
        canCreateLink = false;
      }
    }
    return canCreateLink;
  }

  const getSteps = () => {
    const validations = evaluateValidations();
    if (!validations) {
      return [
        {
          id: "error",
          component: ValidationErrorStep,
        }
      ];
    } else {
      return [
        {
          id: "import",
          component: ImportStep,
        },
        {
          id: "loading",
          component: LoadingStep,
        },
        {
          id: "importResults",
          component: ImportResultsStep,
        },
        {
          id: "error",
          component: ErrorStep,
        },
      ]; 
    }
  }
  
  const steps = getSteps();
  const { step, navigation, reset } = useStep({steps});
  const { component: StepComponent } = step;

  const resetModal = () => {
    reset();
    setIsFetching(false);
    setUploadOk(null);
    setResults([]);
    setError(false);
    setFileName(null);
  }

  const hideAndResetModal = () => {
    resetModal();
    if (typeof props.onCampaignReset === 'function') {
      props.onCampaignReset();
    }
    props.toggle(false);
  };

  const retryModal = () => {
    reset();
  }

  return (
    <Modal
      isOpen={props.isOpen}
      toggle={hideAndResetModal}
      zIndex={100}
      centered
      size="lg"
    >
      <StepComponent
        hideModal={hideAndResetModal}
        resetModal={resetModal}
        retryModal={retryModal}
        navigation={navigation}
        error={error}
        setError={setError}
        isFetching={isFetching}
        setIsFetching={setIsFetching}
        uploadOk={uploadOk}
        setUploadOk={setUploadOk}
        results={results}
        setResults={setResults}
        fileName={fileName}
        setFileName={setFileName}
        subsidiaryId={props.subsidiaryId}
        token={props.token}
        onCampaignSubscribe={props.onCampaignSubscribe}
        onCampaignConfirmed={props.onCampaignConfirmed}
        onConfirmSuccess={props.onConfirmSuccess}
        onCampaignReset={props.onCampaignReset}
        hasActiveCampaign={props.hasActiveCampaign}
        onStartEmailNotification={props.onStartEmailNotification}
        onUpdateNotificationData={props.onUpdateNotificationData}
        isEmailSending={props.isEmailSending}
        showEmailSendingWarning={props.showEmailSendingWarning}
        setShowEmailSendingWarning={props.setShowEmailSendingWarning}
      />
    </Modal>
  );
}

export default MassivePaymentLinkModal;
